export const paymentMethodsMap = {
	adyenDropIn: ['adyen-drop-in', 'adyen-de', 'adyen-sepa'],
	klarnaCheckout: ['klarna-checkout'],
	payPal: ['paypal-new', 'paypal-de'],
};

export const urlRoots = [];

export const checkoutAPI = window?.storeSettings?.checkoutAPI;
